module.exports = __webpack_public_path__ + "static/img/aws-cci-1.778e1c86.png";